import { interfaces } from 'inversify/lib/interfaces/interfaces';

import { overriddenDeps } from './define-module';

export function getOverrideTarget<T>(serviceIdentifier: interfaces.Newable<T>): interfaces.Newable<T> {
  const overrideVariant = overriddenDeps.find(([, overrideResult]) => overrideResult === serviceIdentifier);

  if (overrideVariant) {
    return overrideVariant[0];
  }

  return serviceIdentifier;
}
